export class Config {
  static messagingServer?: string;

  static botName?: string;
  static isReadOnly?: boolean;
  static hideForm?: boolean;
  static hidePastMessages?: boolean;
  static canPressButtons?: boolean;

  static orgId: number;
  static language: string;
  static startOnQuest?: string;
  static position: string;
  static startConversationClosed: boolean;
  static startOpen: boolean;
  static loadPastMessages: boolean;
  static avatarURL: string;
  static showAvatarInHeader: boolean;
  static showAvatarWithTimestamp: boolean;
  static showAvatar: boolean;
  static collapsedStyle: string;
  static headerText: string;
  static dotText: string;
  static linkTarget: string;
  static primaryFont: string;
  static secondaryFont: string;
  static loadPastMessagesColor: string;
  static loadPastMessagesHoverColor: string;
  static loadPastMessagesActiveColor: string;
  static loadPastMessagesSpinnerFill: string;
  static headerBackground: string;
  static headerColor: string;
  static bodyBackground: string;
  static userBubbleBackground: string;
  static userBubbleColor: string;
  static botBubbleBackground: string;
  static botBubbleColor: string;
  static timestampColor: string;
  static formBackground: string;
  static formColor: string;
  static linkColor: string;
  static linkHoverColor: string;
  static sendButtonBackground: string;
  static sendButtonColor: string;
  static sendButtonHoverBackground: string;
  static sendButtonHoverColor: string;
  static sendButtonActiveBackground: string;
  static sendButtonActiveColor: string;
  static primaryButtonBackground: string;
  static primaryButtonColor: string;
  static primaryButtonHoverBackground: string;
  static primaryButtonHoverColor: string;
  static primaryButtonActiveBackground: string;
  static primaryButtonActiveColor: string;
  static secondaryButtonBackground: string;
  static secondaryButtonColor: string;
  static secondaryButtonHoverBackground: string;
  static secondaryButtonHoverColor: string;
  static secondaryButtonActiveBackground: string;
  static secondaryButtonActiveColor: string;
  static showCTA?: boolean;
  static ctaDelay?: number;
  static ctaTitle?: string;
  static ctaImageURL?: string;
  static ctaBody?: string;
  static ctaStartOnQuest?: string;
  static dotDesktopLeftOffset?: number;
  static dotDesktopRightOffset?: number;
  static bodyDesktopLeftOffset?: number;
  static bodyDesktopRightOffset?: number;
  static preloadVariables?: { [key: string]: string };
}
